/**
 * Alarm table column model, kept out of the component file for fast refresh.
 *
 * Every flexible track is `minmax(0, …)`: with `minmax(<px>, …)` a long entity
 * name or a wide pill pushes the track past its share and the last column ends
 * up under the window edge. A zero minimum lets the cell truncate instead.
 */
export const ALARM_COLUMNS = [
  { key: 'severity', label: 'Severity', width: '88px', phone: true },
  { key: 'state', label: 'State', width: '134px', phone: false },
  { key: 'entity', label: 'Entity', width: 'minmax(0, 1.3fr)', phone: false },
  { key: 'title', label: 'Alarm', width: 'minmax(0, 2.4fr)', phone: true },
  { key: 'source', label: 'Source', width: 'minmax(0, 0.9fr)', phone: false },
  { key: 'count', label: 'Count', width: '56px', phone: false },
  { key: 'age', label: 'Age', width: '52px', phone: true },
  { key: 'assignee', label: 'Assignee', width: '60px', phone: false },
] as const;

/** The columns a phone shows; the rest are dropped rather than squeezed. */
export const PHONE_COLUMNS = ALARM_COLUMNS.filter((column) => column.phone).map((c) => c.key);

export type AlarmColumnKey = (typeof ALARM_COLUMNS)[number]['key'];

export type Density = 'comfortable' | 'compact';

export const ROW_HEIGHT: Record<Density, number> = { comfortable: 44, compact: 32 };

/** Below this many rows the table renders everything; above it, it virtualises. */
export const VIRTUALIZE_THRESHOLD = 60;
